import "core-js/modules/es.function.name";
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./svg-icon.css";

function SVGIcon(_ref) {
  var name = _ref.name,
      flip = _ref.flip,
      rotate = _ref.rotate,
      className = _ref.className;
  var useTag = "<use xlink:href=\"#".concat(name, "\" />");
  var inlineStyles = {};

  if (rotate) {
    inlineStyles["transform"] = "rotate(".concat(rotate, "deg)");
  } else if (flip) {
    inlineStyles["transform"] = "rotateY(180deg)";
  }

  return React.createElement("svg", {
    style: inlineStyles,
    className: classnames(styles.svgIcon, "svg-icon-".concat(name), className),
    dangerouslySetInnerHTML: {
      __html: useTag
    }
  });
}

export default SVGIcon;
SVGIcon.propTypes = {
  flip: PropTypes.bool,
  name: PropTypes.string.isRequired,
  rotate: PropTypes.number,
  className: PropTypes.string
};
SVGIcon.defaultProps = {
  flip: false
};